export default {
  emptyState() {
    this.replaceState({ toolbar: null });
  },

  UPDATE(state, payload) {
    state.toolbar = Object.assign(state.toolbar, payload);
  },
};
